import { Action } from 'redux';
import { ClassifierModel } from '../../../api/admin/admin.types';
import { Page } from '../../../api/api.types';

export const GET_CLASSIFIER_LIST = 'GET_CLASSIFIER_LIST';
export const GET_CLASSIFIER = 'GET_CLASSIFIER';
export const POST_CLASSIFIER = 'POST_CLASSIFIER';
export const PUT_CLASSIFIER = 'PUT_CLASSIFIER';
export const DELETE_CLASSIFIER = 'DELETE_CLASSIFIER';

export interface ClassifierState {
  classifiers: ClassifierModel[] | [];
  selectedClassifier: ClassifierModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
}

export interface GetClassifierListAction extends Action {
  type: typeof GET_CLASSIFIER_LIST;
  payload: {
    page: Page<ClassifierModel>;
  };
}

export interface GetClassifierAction extends Action {
  type: typeof GET_CLASSIFIER;
  payload: {
    selectedClassifier: ClassifierModel | null;
  };
}

export interface PostClassifierAction extends Action {
  type: typeof POST_CLASSIFIER;
  payload: {
    success: boolean;
    newClassifier: ClassifierModel | null;
  };
}

export interface PutClassifierAction extends Action {
  type: typeof PUT_CLASSIFIER;
  payload: {
    selectedClassifier: ClassifierModel;
  };
}

export interface DeleteClassifierAction extends Action {
  type: typeof DELETE_CLASSIFIER;
  payload: {
    success: boolean;
  };
}

export type ClassifierActionTypes =
  GetClassifierListAction
  | GetClassifierAction
  | PostClassifierAction
  | DeleteClassifierAction
  | PutClassifierAction;
